import React from "react";
import { useUserContext } from "context/UserContext";
import ExposureSP from "layouts/SP/exposure";
import { normalizeRoleLevel } from "utils/roleUtils";

function Exposures() {
  const { roleLevel } = useUserContext() || {};
  if (!normalizeRoleLevel(roleLevel)) {
    return <ExposureSP />;
  }
  return null;
}

export default Exposures;
